// Utility centralizado com singleton para tocar sons de notificação sem criar múltiplos AudioContext
let cachedCtx = null;
const getAudioCtx = () => {
  const Ctx = (typeof window !== 'undefined') && (window.AudioContext || window.webkitAudioContext);
  if (!Ctx) return null;
  if (!cachedCtx) {
    try { cachedCtx = new Ctx(); } catch { cachedCtx = null; }
  }
  return cachedCtx;
};

export const createNotificationSound = async () => {
  try {
    const audioContext = getAudioCtx();
    if (!audioContext) throw new Error('AudioContext indisponível');
    if (audioContext.state === 'suspended') {
      try { await audioContext.resume(); } catch {}
    }

    const createBeep = (frequency, duration, volume = 0.1) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      const now = audioContext.currentTime;
      gainNode.gain.setValueAtTime(volume, now);
      gainNode.gain.exponentialRampToValueAtTime(0.001, now + duration);
      oscillator.start(now);
      oscillator.stop(now + duration);
      return oscillator;
    };

    createBeep(800, 0.15, 0.1);
    setTimeout(() => createBeep(1000, 0.15, 0.1), 200);
    setTimeout(() => createBeep(800, 0.15, 0.1), 400);
  } catch (_) {
    try {
      const audio = new Audio("data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+L0t2sdBTGH0fPTgjMGHnzJ8N+WRgsTWK/n77BdGAg+ltryxnkpBi2Bz/LXizoIGGS57+OWT");
      audio.volume = 0.1;
      audio.play().catch(() => {});
    } catch {}
  }
};

export const playTaskNotification = () => {
  if (typeof window !== 'undefined') {
    createNotificationSound();
  }
};

export default { createNotificationSound, playTaskNotification };
